import React from "react";
import { connect } from "react-redux";

import { steps } from './Wizard';

const Steps = ({
  currentStep,
}) => (
  <ul className="step-navigation">
    {steps.map((step, idx) => (
      <li
        key={idx}
        className={idx === currentStep ? "active" : ""}
      >
        {idx + 1}. {step.title}
      </li>
    ))}
  </ul>
);

const mapStateToProps = state => ({
  currentStep: state.currentStep
});

export default connect(mapStateToProps)(Steps);
